import { 
  usdtContract,
  safeContract, islContract, islConAdd

        } from "./ConAddsAndABIs"
import React, { useEffect, useState } from "react";

function TheInitialLiquidity(){

const [buySafeValue, setBuySafeValue] = useState(""); 
const [remainingSafe, setRemainingSafe] = useState('');
const [safeSold, setSafeSold] = useState('');
const [usdcGenerated, setUsdcGenerated] = useState('');
const [safePrice, setSafePrice] = useState('');

useEffect(() => {  
 
// - - - - - - - - - - 
const getTotalUsdtRewards = async () => {
    const a = await safeContract.balanceOf(islConAdd) / (10**18);
    const b = a.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
    const c = 600000000 - a;
    const d = c.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
    const e = await islContract.totalUSDTGenerated() / 1 + 3004;
    const f = e.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})   
    const g = await islContract.safePrice() / 1000000
    const h = g.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 6})
    setRemainingSafe(b)
    setSafeSold(d)
    setUsdcGenerated(f)
    setSafePrice(h)


  }  

  getTotalUsdtRewards()
  .catch(console.error)


})

const handleBuySafeValueChange = (e) => {
    setBuySafeValue(e.target.value);
    }  
   
const handleBuySafeValueSubmit = async (e) => {
    e.preventDefault();
    console.log(buySafeValue)
    const price = await islContract.safePrice() / 1;
    const safePerUsd = 1000000 / price 
    const inUsdc = buySafeValue * 1.01 * (10 ** 6) / safePerUsd 
    /*const inUsdca = inUsdc.toLocaleString(undefined, {minimumFractionDigits: 6, maximumFractionDigits: 7})
    const uintValuea = ethers.utils.parseUnits(inUsdca, 6)*/
    const txna = await usdtContract.approve(islConAdd, inUsdc)
    await txna.wait();  
    const txnb = await islContract.buySafe(buySafeValue)
    await txnb.wait();
    setBuySafeValue(0);
    }

return ( 
  <div>
        <h2>Presale Phase 1 (Initial Liquidity) Ladder Vault</h2><br/>

        <form style={{"textAlign": "center"}} onSubmit={handleBuySafeValueSubmit}>
            <input style={{"width": "200px"}} type="number" className="form-control" placeholder="0" onChange={handleBuySafeValueChange} value={buySafeValue} /> <button style={{"width": "150px"}} type={"submit"} className="btn btn-success">Buy SAFE for {safePrice} USDC each</button>
        </form><br/> 

      <table className="tableA">
        <tbody>
            <tr>
                <th style={{"width": "75%"}}>Global Metrics</th>
                <th style={{"width": "25%"}}>Stats</th>
            </tr>
            <tr>
                <td>Remaining Presale Amount</td>
                <td className="column2">{remainingSafe} $SAFE</td>
            </tr>
            <tr>
                <td>Total SAFE Sold</td>
                <td className="column2">{safeSold} $SAFE</td>
            </tr>   
            <tr>
                <td>Total USDC Generated</td>
                <td className="column2">{usdcGenerated} $USDC</td>
            </tr>                                                                                                                           
        </tbody>               
      </table><br />
  

  </div>
  
)

}


export default TheInitialLiquidity;